import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import { IActionModalHandler } from "components/actionModal/ActionModal";
import PromiseBottomModal from "components/promiseBottomModal/PromiseBottomModal";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { TransactionType } from "domains/order/agreggates/payment/transactionType";
import React, { FC, useCallback, useRef } from "react";
import { ReactComponent as Attention } from "../../../../../assets/icons/attention.svg";
import { ReactComponent as Credit } from "../../../../../assets/icons/credit.svg";
import { ReactComponent as Debit } from "../../../../../assets/icons/debit.svg";
import { ReactComponent as Pix } from "../../../../../assets/icons/pix.svg";
import "./SelectCardType.css";
import { useTranslation } from "i18n/useTranslation";

interface SelectCardTypeProps {
  kiosk: Kiosk;
  onSelect: (value: TransactionType) => void;
  rechargePayment?: boolean;
}
export const SelectCardType: FC<SelectCardTypeProps> = ({
  onSelect,
  kiosk,
  rechargePayment,
}) => {
  const actionModalRef = useRef<IActionModalHandler>(null);

  const { resolution } = useScreenStore();
  const { t } = useTranslation();

  const onSelectType = useCallback(
    async (type: TransactionType) => {
      try {
        await actionModalRef.current?.open();
        onSelect(type);
      } catch (error) {
        console.log(error);
      }
    },
    [onSelect]
  );

  return (
    <div className="select-card-type">
      <div className="buttonsContainer-select-card-type">
        {kiosk?.paymentCredit && (
          <div
            onClick={() => onSelectType(TransactionType.credit)}
            className="button-select-card-type"
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <Credit
              color="var(--primary)"
              style={{
                height: resolution === ResolutionType.FULL_HD ? 65 : 45,
                width: resolution === ResolutionType.FULL_HD ? 65 : 45,
              }}
            />
            <p> {t("select_card_type.credit")}</p>
          </div>
        )}
        {kiosk?.paymentDebit && (
          <div
            onClick={() => onSelectType(TransactionType.debit)}
            className="button-select-card-type"
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <Debit
              color="var(--primary)"
              style={{
                height: resolution === ResolutionType.FULL_HD ? 65 : 45,
                width: resolution === ResolutionType.FULL_HD ? 65 : 45,
              }}
            />
            <p> {t("select_card_type.debit")}</p>
          </div>
        )}
        {kiosk?.paymentVoucher && (
          <div
            onClick={() => onSelectType(TransactionType.voucher)}
            className="button-select-card-type"
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <Debit
              color="var(--primary)"
              style={{
                height: resolution === ResolutionType.FULL_HD ? 65 : 45,
                width: resolution === ResolutionType.FULL_HD ? 65 : 45,
              }}
            />
            <p> {t("select_card_type.voucher")}</p>
          </div>
        )}
        {kiosk?.paymentPix && (
          <div
            onClick={() => onSelectType(TransactionType.pix)}
            className="button-select-card-type"
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <Pix
              color="var(--primary)"
              style={{
                height: resolution === ResolutionType.FULL_HD ? 65 : 45,
                width: resolution === ResolutionType.FULL_HD ? 65 : 45,
              }}
            />
            <p>{t("select_card_type.pix")}</p>
          </div>
        )}
        {kiosk?.paymentCashless /* && !isPreOrPos()*/ && !rechargePayment && (
          <div
            onClick={() => onSelectType(TransactionType.cashless)}
            className="button-select-card-type"
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 32 : 24,
            }}
          >
            <Credit
              color="var(--primary)"
              style={{
                height: resolution === ResolutionType.FULL_HD ? 65 : 45,
                width: resolution === ResolutionType.FULL_HD ? 65 : 45,
              }}
            />
            <p>{t("select_card_type.cashless")}</p>
          </div>
        )}
      </div>
      <PromiseBottomModal
        ref={actionModalRef}
        confirmTitle={t("select_card_type.confirm")}
        SvgIcon={Attention}
        message={t("select_card_type.message")}
        title={t("select_card_type.title")}
        hideCloseButton
      />
    </div>
  );
};
